"use client";
import React from "react";
import Image from "next/image";
import { AppBar, Toolbar } from "@mui/material";
import { IMAGES, WEB_COLORS } from "@/lib/constants";

const Navbar = () => {
  return (
    <>
      <AppBar position="static" sx={{ bgcolor: WEB_COLORS.pale }}>
        <Toolbar>
          <Image
            width={110}
            height={80}
            alt="Hero FinCorp"
            src={IMAGES.navbarLogo}
          />
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Navbar;
